// Components==============
import { AnimatePresence, motion } from 'framer-motion';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import React, { useRef, useState } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import './Tooltip.module.scss';
// =========================

type Position = 'top' | 'right' | 'bottom' | 'left' | 'bottom-right';

type Props = {
  content: string | React.ReactNode;
  children: React.ReactNode | string;
  position?: Position;
  disabled?: boolean;
};

export default function TooltipMenu({
  content,
  children,
  position = 'top',
  disabled = false,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside({
    handler: () => setIsOpen(false),
    condition: isOpen,
    refs: [ref],
  });

  if (disabled) return <>{children}</>;

  return (
    <div
      ref={ref}
      styleName="wrapper tooltip-menu"
      style={{ pointerEvents: disabled ? 'none' : 'all' }}
    >
      <div onClick={() => setIsOpen((prev) => !prev)} styleName="button">
        {children}
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div {...framerFade} styleName={`tooltip-content ${position}`}>
            {content}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
